﻿import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import {
    retirementGuideUpdateFormDataAction,
    retirementGuideUpdateChartAction
} from '../State/actions';

import RawHtml from '../../../UI/RawHtml';

import Form from '../../../../vendor/react-validation/components/form';
import NumberInput from '../../../Forms/Components/NumberInput';

import getFormValues from '../../../Forms/getFormValues';
import {required} from '../../../Forms/Validation/rules';

import throttle from '../../../Utils/throttle';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';
import constants from '../constants';
import { ButtonWrapper } from '../../TravelCertificatePage/TravelCertificatePage';


class GuideResult extends React.Component {
    static get propTypes() {
        return {
            epiHeaderData: PropTypes.object.isRequired
        };
    }

    handleFormChange = throttle((e) => {
        this.props.updateFormData(getFormValues(this.form));
        this.props.updateChart();
    }, 200);


    refreshPage() {
        location.reload();
    }

    updateFormData(key, val) {
        const form = this.props.formData;
        form[key] = val;
        this.props.updateFormData(form);
        this.props.updateChart();
    }

    alterValue(key, by) {
        const form = this.props.formData;
        const currentValue = parseInt(form[key]);

        let min = Math.min(1000, currentValue);

        this.updateFormData(key, Math.max(min, currentValue + by));
    }

    decreaseValue(key, event) {
        event.preventDefault();
        this.alterValue(key, -constants.GUIDE_RESULT_ADD_BUTTON_SEK_INTERVAL);
    }

    increaseValue(key, event) {
        event.preventDefault();
        this.alterValue(key, constants.GUIDE_RESULT_ADD_BUTTON_SEK_INTERVAL);
    }

    render() {
        const data = this.props.data.displayData;
        const showPrivateSavings = this.props.data.age < constants.AGE_SAVINGS_LIMIT;

        return (
            <ResultWrapper>
                {/* <ResultHeading>En underrubrik</ResultHeading> */}
                <ResultPreamble>
                    {!showPrivateSavings && (
                        <div>
                            <h4>Om du närmar dig pensionsåldern</h4>
                            <p>Guiden ger korrektare siffror ju längre du är från pensionen. Därför visas inte förslag på eget sparande efter 55 år, då siffrorna lätt blir missvisande. Istället rekommenderar vi en individuell pensionsplanering eller pensionsrådgivning för att du ska få en korrekt bild av individuellt sparande.</p>
                        </div>
                    )}
                    <RawHtml>
                        {this.props.epiHeaderData.preambles.resultPreamble}
                    </RawHtml>
                </ResultPreamble>
                <Form ref={el => { this.form = el; }} onChange={this.handleFormChange}>
                    <FormRow>
                        {showPrivateSavings && (
                            <FormColumn>
                                <Box backgroundColor={definitions.colors.orange} className="rounded">
                                    <InputWrapper>
                                        <h4>Önskad pension</h4>
                                        <p>Ange önskad pension per månad:</p>

                                        <InputButtonWrapper>
                                            <InputChangeButton subtract color={definitions.colors.orange} onClick={(ev) => { this.decreaseValue('wantedMonthlyPension', ev); }} />
                                            <NumberInput
                                                className="rounded"
                                                theme="big"
                                                colorScheme="white"
                                                id="wantedMonthlyPension"
                                                name="wantedMonthlyPension"
                                                innerLabel="kr"
                                                padding="small"
                                                min="1"
                                                data-validation-error-message="Ange din önskade pension"
                                                validations={[required]}
                                                placeholder="0"
                                                value={this.props.formData.wantedMonthlyPension}
                                            />
                                            <InputChangeButton color={definitions.colors.orange} onClick={(ev) => { this.increaseValue('wantedMonthlyPension', ev); }} />
                                        </InputButtonWrapper>
                                    </InputWrapper>
                                </Box>
                            </FormColumn>
                        )}
                        <FormColumn>
                            <Box backgroundColor={definitions.colors.blueBackground} className="rounded">
                                <InputWrapper>
                                    <h4>Månadslön</h4>
                                    <p>Din nuvarande månadslön som används för att utföra beräkningar:</p>
                                    <InputButtonWrapper>
                                        <InputChangeButton subtract color={definitions.colors.blueBackground} onClick={(ev) => { this.decreaseValue('monthlySalary', ev); }} />
                                        <NumberInput
                                            className="rounded"
                                            theme="big"
                                            colorScheme="white"
                                            id="monthlySalary"
                                            name="monthlySalary"
                                            innerLabel="kr"
                                            padding="small"
                                            min="1"
                                            data-validation-error-message="Ange din inkomst"
                                            validations={[required]}
                                            placeholder="0"
                                            value={this.props.formData.monthlySalary}
                                        />
                                        <InputChangeButton color={definitions.colors.blueBackground} onClick={(ev) => { this.increaseValue('monthlySalary', ev); }} />
                                    </InputButtonWrapper>
                                </InputWrapper>
                            </Box>
                        </FormColumn>
                        {showPrivateSavings && (
                            <FormColumn>
                                <Box backgroundColor={definitions.colors.green} className="rounded">
                                    <InputWrapper>
                                        <h4>Sparande</h4>
                                        <h6>Du måste varje månad spara</h6>
                                        <ResultValue>ca. {Math.max(0, data.monthlySavingsNeeded)} kr</ResultValue>
                                    </InputWrapper>
                                </Box>
                            </FormColumn>
                        )}
                        <FormColumn>
                            <Box backgroundColor={'#EF3C76'} higherOnResponsive={true} className="rounded">
                                <ContentWrapper>
                                    <ContentRow paddingBottom={true}>
                                        <h4>Uppskattad pension</h4>
                                        <h5>(per månad)</h5>
                                    </ContentRow>

                                    <ContentColumn>
                                        <ContentColumnInner>
                                            <h6>Allmän pension</h6>
                                            <span>ca. {data.totalPublicPension} kr</span>
                                        </ContentColumnInner>
                                        <ContentColumnInner>
                                            <h6>Tjänstepension</h6>
                                            <span>ca. {data.occupationalPension} kr</span>
                                        </ContentColumnInner>
                                    </ContentColumn>
                                    {showPrivateSavings && (
                                        <ContentColumn>
                                            <ContentColumnInner>
                                                <h6>Eget sparande</h6>
                                                <span>ca. {data.privateSavingsPension > 0
                                                        ? data.privateSavingsPension
                                                        : 0
                                                    } kr</span>
                                            </ContentColumnInner>
                                        </ContentColumn>
                                    )}
                                    <ContentRow paddingTop={true}>
                                        <ResultValue bordered>Totalt ca. {showPrivateSavings ? data.totalPension : data.totalPensionNoSavings} kr</ResultValue>
                                    </ContentRow>
                                </ContentWrapper>
                            </Box>
                        </FormColumn>
                    </FormRow>
                </Form>
                <PensionGuidanceCta autoHeight>
                    <h4>{this.props.epiHeaderData.headings.resultPensionConsultingHeader}</h4>
                    <RawHtml>{this.props.epiHeaderData.preambles.resultPensionConsultingPreamble}</RawHtml>
                    <ButtonContainer>
                        <a role="button" href={this.props.epiHeaderData.links.resultPensionConsultingLink}><span className="button button--green">Boka rådgivning</span></a>
                        <button onClick={(ev) => { ev.preventDefault(); this.refreshPage(); }}><span className="button button--outline">Gör testet igen</span></button>
                    </ButtonContainer>
                </PensionGuidanceCta>
            </ResultWrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.retirementGuideChartData.chartData,
        formData: state.retirementGuideFormData.formData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFormData: (data) => dispatch(retirementGuideUpdateFormDataAction((data))),
        updateChart: () => dispatch(retirementGuideUpdateChartAction())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GuideResult);

// styles

const propsToExclude = ['color', 'subtract'];

const InputChangeButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !propsToExclude.includes(prop)
})`
    background-color: white;
    margin-left: 10px;
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 32px;

    &:hover {
        opacity: 0.8;
    }

    &:after {
        content: '+';
        position: absolute;
        display: block;
        top: 50%;
        left: 50%;
        color: black;
        transform: translate(-50%, -50%);

        ${props => props.color && `
            color: ${props.color};
        `}


        ${iconCode.plus()}
    }

    ${props => props.subtract && `
        margin-left: 0px;
        margin-right: 10px;

        &:after {
            content: '–';
            line-height: 12px;
            height: 20px;
            width: 20px;
            font-size: 27px;
        }
    `}
`;

const InputButtonWrapper = styled.div`
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
`;
const ResultHeading = styled.h2`
    margin-top: 0;
    margin-bottom: 10px;
`;

const ResultPreamble = styled.div`
    margin: 0 15px 60px 15px;
`;

const ResultWrapper = styled.div`
    margin: 0 auto;
    margin-bottom: 30px;
    max-width: 1000px;

    text-align: center;
`;

const FormRow = styled.div`
    position: relative;
    margin-bottom: 30px;

    ${mediaQuery.custom(`
        margin-bottom: 0;
    `, '1005px')};

    ${clearFix()}
`;

const FormColumn = styled.div`
    position: relative;
    width: 50%;
    height: 100%;
    float: left;

    margin-bottom: 30px;

    ${mediaQuery.custom( `
        width: 100%;
        margin-bottom: 30px;
    `, '1005px')};
`;

const boxPropsToExclude = ['backgroundColor', 'autoHeight', 'higherOnResponsive'];

const Box = styled.div.withConfig({
shouldForwardProp: (prop) => !boxPropsToExclude.includes(prop)
})`
    position: relative;
    height: 100%;
    margin: 0 15px 0 15px;

    background-color: ${props => props.backgroundColor};
    color: white;

    height: 400px;

    ${mediaQuery.small(`
        height: 340px;
    `)};

    ${props => props.autoHeight && `
        height: auto;
    `}

    ${props => props.higherOnResponsive &&
        mediaQuery.xsmall(`
            height: 510px;
        `)
    }

    ${mediaQuery.medium(`
        h4 {
            font-size: 28px;
        }
    `)};
`;

const InputWrapper = styled.div`
    position: absolute;
    text-align: center;
    width: 100%;
    padding: 30px;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);

    h6 {
        margin: 10px 0 20px 0;

        ${mediaQuery.xsmall(`
            margin: 10px 0;
        `)}
    }

    p {
        margin-bottom: 15px;
        ${mediaQuery.xsmall(`
            margin-bottom: 10px;
        `)}
    }

    strong {
        font-weight: bold;
        font-family: inherit;
    }
`;

const ContentWrapper = styled.div`
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);

    ${clearFix()}

    text-align: center;

    h5 {
        ${mediaQuery.xsmall(`
            margin: 10px 0 0 0;
        `)}
    }

    h6 {
        margin: 20px 0 0 0;

        ${mediaQuery.xsmall(`
            margin: 10px 0;
        `)}
    }

    ${mediaQuery.xsmall(`
        h4 + h5 {
            margin-bottom: 15px;
        }
    `)}
`;

const contentPropsToExclude = ['paddingTop', 'paddingBottom'];

const ContentRow = styled.div.withConfig({
    shouldForwardProp: (prop) => !contentPropsToExclude.includes(prop)
})` 
    position: relative;
    width: 100%;
    float: left;

    text-align: center;

    padding-top: ${props => props.paddingTop
        ? '15px;'
        : '0;'
    }

    padding-bottom: ${props => props.paddingBottom
        ? '15px;'
        : '0;'
    }

    h5 {
        font-family: ${definitions.fonts.main};
        ${mediaQuery.small(`
            font-size: 18px;
        `)};
    }
`;

const ContentColumn = styled.div`
    position: relative;
    width: 100%;
    text-align: center;
`;

const ContentColumnInner = styled.div`
    display: inline-block;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 80px;

    ${mediaQuery.small(`
        display: block;
        padding: 0 20px;
    `)};

    h5, h6  {
        margin-top: 10px;
        margin-bottom: 3px;
        font-weight: normal;
        font-size: 20px;
        line-height: 28px;
        text-align: left;
        width: 50%;
        ${mediaQuery.small(`
            width: auto;
            text-align: center;
        `)};
    }

    span {
        font-size: 20px;	
        font-weight: bold;	
        line-height: 28px;	
        text-align: right;
        width: 50%;
        ${mediaQuery.small(`
            width: auto;
            text-align: center;
        `)};

    }

    strong {
        font-weight: bold;
        font-family: inherit;
    }
`;


const PensionGuidanceCta = styled(Box)`
    background-color: transparent;
    color: black;
    margin-top: 80px;

    h4 {
        color: inherit;
        font-size: 56px;
        margin-bottom: 15px;

        ${mediaQuery.medium(`
            font-size: 46px;
        `)};

        ${mediaQuery.small(`
            font-size: 36px;
        `)};
    }
`;

const ButtonContainer = styled.div`
    width: 45%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;

    ${mediaQuery.small(`
        width: 100%;
        justify-content: center;
    `)};
`;

const resultValuePropsToExclude = ['bordered'];

const ResultValue = styled.div.withConfig({
    shouldForwardProp: (prop) => !resultValuePropsToExclude.includes(prop)
})`
    font-size: 30px;
    font-weight: bold;
    line-height: 36px;
    display: inline-block;
    font-family: ${definitions.fonts.heading};
    
    ${mediaQuery.small(`
        line-height: 26px;
        font-size: 20px;
    `)};

    ${props => props.bordered && `
        border-top: 1px solid #fff;
        padding-top: 20px;
        margin-top: 20px;

        ${mediaQuery.small(`
            border-top: 0px solid #fff;
        `)};
    `}
`;
